import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledContainer = styled.div`
  display: flex;
  align-items: end;
  img {
    margin-right: 8px;
  }
`
interface IProps {
  title?: string
  children?: ReactNode
  preIcon?: string
}

const ModalTitle = (props: IProps) => {
  const { t } = useTranslation()
  const { children, title, preIcon } = props
  return (
    <StyledContainer>
      <img src={preIcon} alt="" />
      {children ?? <div>{t(title || '')}</div>}
    </StyledContainer>
  )
}

export default ModalTitle
